import Vue from "vue";
import App from "./App.vue";
import "./styles/app.less";
import { globalState } from "./globalState";

Vue.config.productionTip = false;

new Vue({
  render: h => h(App),
  data: {
    globalState
  }
}).$mount("#app");
